export default "__VITE_ASSET__C4J7hil$__"